import { render, staticRenderFns } from "./TiemposPorDepartamento.vue?vue&type=template&id=512bc7cb&scoped=true"
import script from "./TiemposPorDepartamento.vue?vue&type=script&lang=js"
export * from "./TiemposPorDepartamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512bc7cb",
  null
  
)

export default component.exports